(
    function (skyward, $, undefined) {
        skyward.payroll = skyward.payroll || {};

        var init = function (selector) {

            if ($(selector).find('#AssignmentPayTypePayTransactionSummary').length > 0) {
                setBrowseVariables();

                $(selector).find('.js-payroll-payrollrun-timetransactionadd').each(function (key, value) {
                    var element = $(value);
                    element.on('change', function (event) {
                        generateAddPayTransactionFilter(selector);
                    });
                });
            }

            if ($(selector).find('#selectPayTransactionsToMove').length > 0)
            {
                setBrowseVariables();

                $(selector).find('.js-Payroll-ConversionContractBalanceFixUtility').each(function (key, value)
                {
                    var element = $(value);
                    element.on('change', function (event)
                    {
                        generateSelectPayTransactionFilter(selector);
                    });
                });
            }

        };

        var setBrowseVariables = function () {
            browseName = skyward.browse.getCurrentBrowseName();
            browse = skyward.browse.browseList[browseName];
            browseInitialFilter = browse.data.filter;
            browseInitialRouteHash = browse.routeHash;
        };

        var getBrowseFilter = function (searchCondition) {
            return searchCondition ? skyward.extensions.encodeHtml(searchCondition) : browseInitialFilter;
        };

        var generateAddPayTransactionFilter = function (selector) {
            var postData = {};

            var assignmentPayTypeID = skyward.controls.getValue($(selector).find('#AssignmentPayTypeID_value'));
            postData.AssignmentPayTypeID = assignmentPayTypeID;

            var startDate = skyward.controls.getValue($(selector).find('#StartDate'));
            postData.StartDate = startDate;

            var endDate = skyward.controls.getValue($(selector).find('#EndDate'));
            postData.EndDate = endDate;

            var stringifiedPostData = JSON.stringify(postData);

            previousPostData = stringifiedPostData;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Payroll/PayTransaction/GenerateAddPayTransactionFilter",
                    type: "POST",
                    dataType: "JSON",
                    data:
                        {
                            BrowseName: browse.browseName,
                            TaskName: browse.taskName,
                            PayTransactionData: stringifiedPostData
                        },
                    success: function (data) {
                        browse.data.filter = getBrowseFilter(data.SearchCondition);
                        browse.queryParameterData.AssignmentPayTypeID = assignmentPayTypeID;
                        browse.queryParameterData.StartDate = startDate;
                        browse.queryParameterData.EndDate = endDate;
                        browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                        skyward.browse.get(browseName, {});
                    }
                })
        };

        var generateSelectPayTransactionFilter = function (selector)
        {
            var postData = {};

            var assignmentPayTypeID = skyward.controls.getValue($(selector).find('#AssignmentPayTypeIDSource'));
            postData.AssignmentPayTypeIDSource = assignmentPayTypeID;

            var stringifiedPostData = JSON.stringify(postData);

            previousPostData = stringifiedPostData;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Payroll/AssignmentPayType/GenerateSelectPayTransactionFilter",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        BrowseName: browse.browseName,
                        TaskName: browse.taskName,
                        AssignmentPayTypeData: stringifiedPostData
                    },
                    success: function (data)
                    {
                        browse.data.filter = getBrowseFilter(data.SearchCondition);
                        browse.queryParameterData.AssignmentPayTypeIDSource = assignmentPayTypeID;
                        browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                        skyward.browse.get(browseName, {});
                    }
                })
        };


        skyward.window.registerLoadDOMCallback(init);

        //Changes here need to be replicated in Skyward.Business.Payroll.ConfigDistrict as well.
        skyward.payroll.resetmessagetemplate = function ()
        {
            var payrollACHMessageSubject = $('#editConfigDistrict_PayrollACHMessageSubject');
            var payrollACHMessageContent = $('#editConfigDistrict_PayrollACHMessageContent');
            var defaultPayrollACHMessageSubject = 'ACH is available for {CheckTransactionPayroll.Employee.Name.FullNameLFM}';
            var defaultPayrollACHMessageContent = 'An ACH payment of ${Amount} will be available on {PayrollRun.CheckDate}.';

            skyward.controls.setValue(payrollACHMessageSubject, defaultPayrollACHMessageSubject, false);
            skyward.controls.setValue(payrollACHMessageContent, defaultPayrollACHMessageContent, false);
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);